import Vue from '@/main'
import { getCurrentTenant, getCurrentRoute } from '@/utils'
import customerGroup from "@/http/requests/customerGroup"

export default {
  fetchGroupsOfCustomerPaginated({ commit }, params) {
    return new Promise((resolve, reject) => {
      customerGroup.fetchGroupsOfCustomerPaginated(
        params.word,
        params.sortName,
        params.type,
        params.page,
        params.itemsPerPage
      ).then(response => {

        commit('SET_GROUPS_OF_CUSTOMER', response.data.data.groupOfCustomerPaginated)
        Vue.$events.on('GroupOfCustomersUpdated', (event) => {

          if (event.tenantName === getCurrentTenant() && '/crm/category' == getCurrentRoute()) {
            customerGroup.infosGroupOfCustomer( event.groupOfCustomer.id )
            .then((response) => {
              commit('UPDATE_GROUP_OF_CUSTOMER', response.data.data.groupOfCustomerInfos)
            });
          }
        });
        resolve(response)
      })
      .catch((error) => {
        reject(error) 
      });
    });
  },
  fetchGroupsOfCustomerTagListById(_, target) {
    return new Promise((resolve, reject) => {
      customerGroup.fetchGroupsOfCustomerTagListById(target.id)
      .then(response => {
        resolve(...response.data.data.groupsOfCustomer);
      })
      .catch((error) => { 
        reject(error); 
      });
    });
  },
  fetchGroupsOfCustomerResume({ commit }) {
    return new Promise((resolve, reject) => {
      customerGroup.fetchGroupsOfCustomerResume(
        null,
        'name',
        'ASC',
        1,
        800,
        false,
        [],
        ['id', 'name']
      ).then(response => {
        commit('SET_GROUPS_OF_CUSTOMER_RESUME', response.data.data.groupOfCustomerPaginated.items);
        resolve(response);
      })
      .catch((error) => { reject(error); })
    })
  },
  infosGroupOfCustomer({ commit }, groupOfCustomerId) {
    return new Promise((resolve, reject) => {
      customerGroup.infosGroupOfCustomer(groupOfCustomerId).then(response => {
        commit('SET_GROUP_OF_CUSTOMER_INFOS', response.data.data.groupOfCustomerInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  addGroupOfCustomer({ commit }, data) {
    return new Promise((resolve, reject) => {
      customerGroup.addGroupOfCustomer(data).then(response => {
        try {
        commit('ADD_GROUP_OF_CUSTOMER', response.data.data.createGroupOfCustomer)
        Vue.$events.on('GroupOfCustomersUpdated', (event) => {
          if (event.tenantName === getCurrentTenant()) {
            customerGroup.infosGroupOfCustomer( event.groupOfCustomer.id )
            .then((response) => {
              commit('UPDATE_GROUP_OF_CUSTOMER', response.data.data.groupOfCustomerInfos)
            }) 
          }
        });
        } catch (exception) {
          console.log(exception);
        }
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  updateGroupOfCustomer({ commit }, data) {
    return new Promise((resolve, reject) => {
      customerGroup.updateGroupOfCustomer(data).then(response => {
        commit('UPDATE_GROUP_OF_CUSTOMER', response.data.data.updateGroupOfCustomer)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  deleteGroupOfCustomer({ commit }, groupOfCustomerId) {
    return new Promise((resolve, reject) => {
      customerGroup.deleteGroupOfCustomer(groupOfCustomerId).then(response => {
        commit('DELETE_GROUP_OF_CUSTOMER', groupOfCustomerId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchCustomerGroups(_, customerId) {
    return new Promise((resolve, reject) => {
      customerGroup.fetchCustomerGroups(customerId).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  deleteCustomerGroup(_, customerGroupId) {
    return new Promise((resolve, reject) => {
      customerGroup.deleteCustomerGroup(customerGroupId).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchDiffGroupsOfCustomer(_, removeIds = []) {
    return new Promise((resolve, reject) => {
      customerGroup.fetchDiffGroupsOfCustomer(removeIds).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchGroupOfCustomerCustomers(_, { groupId, page, limit }) {
    return new Promise((resolve, reject) => {
      customerGroup.fetchGroupOfCustomerCustomers(groupId, page, limit).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
}
